import { useState, useRef, useEffect } from "react";
import { isChildElement } from "./isChildElement";

export const useOutsideClick = (handler: ()=>void)=>{
    const clickableRef = useRef<HTMLDivElement>(null);
    
    useEffect(()=>{
        const windowHandler = (e: MouseEvent)=>{
            if (!isChildElement(e.target as HTMLElement, clickableRef.current)){
                handler();
            }
        }
        window.addEventListener('mousedown', windowHandler, {capture: true});
        return ()=>{
            window.removeEventListener('mousedown', windowHandler, {capture: true});
        }
    }, [clickableRef.current]);
    return clickableRef;
}
